//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    msg: {
      type: String,
      default: '测试'
    },
    time: {
      type: Number,
      default: 1000
    }
  },
  data () {
    return {
      ctr: false,
      _time: null
    }
  },
  methods: {
    toast () {
      this.ctr = true
      this._time = window.setTimeout(() => {
        this.ctr = false
        window.clearTimeout()
      }, this.time)
    }
  }
}



// WEBPACK FOOTER //
// ./src/component/uiToast/uiToast.vue